import PanelSettings from './PanelSettings';
import './PanelSettings.scss';

export default PanelSettings;
